export default "__VITE_ASSET__Cnhm20Eu__"